import {
  API_CALL,
  REQUEST_ADVERTISERS,
  RECEIVE_ADVERTISERS,
  REQUEST_UPDATE_ADVERTISERS,
  RECEIVE_UPDATE_ADVERTISERS,
  ADVERTISERS_FAILED,
  REQUEST_UPDATE_DELIVERY,
  RECEIVE_UPDATE_DELIVERY,
  DELIVERY_FAILED
} from "./types";

export const getAdvertisers = () => ({
  type: API_CALL,
  onRequest: REQUEST_ADVERTISERS,
  onResponse: RECEIVE_ADVERTISERS,
  onError: ADVERTISERS_FAILED,
  payload: {
    method: 'GET',
    url: '/advertisers'
  }
});

export const putAdvertisers = () => ({
  type: API_CALL,
  onRequest: REQUEST_UPDATE_ADVERTISERS,
  onResponse: RECEIVE_UPDATE_ADVERTISERS,
  onError: ADVERTISERS_FAILED,
  payload: {
    method: 'PUT',
    url: `/advertisers`
  }
});

export const updateDelivery = () => ({
  type: API_CALL,
  onRequest: REQUEST_UPDATE_DELIVERY,
  onResponse: RECEIVE_UPDATE_DELIVERY,
  onError: DELIVERY_FAILED,
  payload: {
    method: 'POST',
    url: `/update-delivery`
  }
});
